<ion-header>
  <ion-toolbar>
    <ion-title>Debug</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="auto()">Auto process <ion-icon name="refresh"></ion-icon></ion-button>
      <ion-button (click)="dismiss()">Close <ion-icon name="close-outline"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="dirData !== undefined">
    <div class="flex flex-row gap-2 px-2 mb-2">
      <button (click)="checkValidFiles(dirData, false)" class="block py-2 px-3 bg-slate-400 text-white rounded-xl">Check validity</button>
      <button (click)="checkValidFiles(dirData, true)" class="block py-2 px-3 bg-red text-white rounded-xl">Process validity</button>
      <button (click)="deleteCorruptFiles(dirData)" class="block py-2 px-3 bg-red text-white rounded-xl">Delete .corrupt</button>
    </div>
    <ion-accordion-group>
      <ion-accordion *ngIf="dirCache !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>Local files: {{ dirData.files.length }}</ion-label>
        </ion-item>
        <div slot="content">
          <ion-searchbar
            [debounce]="500"
            class="search-bar min-h-0 pt-0 pb-0 my-2"
            placeholder="File search"
            (ionInput)="setFilteredItems($event)"
          ></ion-searchbar>
          <ng-container *ngFor="let file of dirDataFiltered.files | slice: lowValue : highValue; let i = index">
            <ion-item>
              <ion-button slot="start" color="primary" (click)="checkFileExists(file)">
                <ion-icon name="refresh" slot="icon-only"></ion-icon>
              </ion-button>
              <!-- <ion-icon name="cloud-done-outline" slot="start" color="success" title="File found in cloud" aria-label="File found in cloud"></ion-icon> -->
              <ion-label>
                <!-- <span class="text-green-600">(found)</span>  -->
                {{ file.name }}</ion-label
              >
              <ion-button slot="end" color="danger" (click)="checkValidFile(file)">
                <ion-icon name="refresh" slot="icon-only"></ion-icon>
              </ion-button>
              <ion-button slot="end" color="danger" (click)="checkValidFile(file, true)">
                <ion-icon name="alert-circle" slot="icon-only"></ion-icon>
              </ion-button>
            </ion-item>
          </ng-container>
        </div>
      </ion-accordion>
    </ion-accordion-group>

    <!-- <p class="p-4">Showing max 20 files of {{dirData.files.length}}</p> -->
    <!-- <mat-paginator [length]="dirData.files.length" pageSize="10" (page)="getPaginatorData($event)" showFirstLastButtons="false">
    </mat-paginator> -->
  </ng-container>
  <div class="p-4">
    <ng-container>
      <h2>Found keys</h2>
      <ul *ngIf="foundKeyValues && foundKeyValues.length > 0">
        <li *ngFor="let key of foundKeyValues">{{ key.value.length / 1000 | number: '1.0-0' }} KB: {{ key.key }} - {{ key.value.length }}</li>
      </ul>
    </ng-container>
  </div>
  <ng-container>
    <div class="p-4">
      <h2>File system</h2>
    </div>
    <ion-accordion-group>
      <ion-accordion *ngIf="dirCache !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>Cache: {{ dirCache.files.length }}</ion-label>
          <ion-button slot="end" color="danger" (click)="deleteUuidFoldersAction()">
            <ion-icon name="trash" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-item>
        <div slot="content">
          <ion-item *ngFor="let file of dirCache.files"> {{ file.name }} </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion *ngIf="dirData !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>Data: {{ dirData.files.length }}</ion-label>
        </ion-item>
        <div slot="content">
          <ion-item *ngFor="let file of dirData.files"> {{ file.name }} </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion *ngIf="dirDoc !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>Docs: {{ dirDoc.files.length }}</ion-label>
        </ion-item>
        <div slot="content">
          <ion-item *ngFor="let file of dirDoc.files"> {{ file.name }} </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion *ngIf="dirExt !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>Ext: {{ dirExt.files.length }}</ion-label>
        </ion-item>
        <div slot="content">
          <ion-item *ngFor="let file of dirExt.files"> {{ file.name }} </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion *ngIf="dirExtStorage !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>ExtStorage: {{ dirExtStorage.files.length }}</ion-label>
        </ion-item>
        <div slot="content">
          <ion-item *ngFor="let file of dirExtStorage.files"> {{ file.name }} </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion *ngIf="dirDcim !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>DCIM: {{ dirDcim.files.length }}</ion-label>
        </ion-item>
        <div slot="content">
          <ion-item *ngFor="let file of dirDcim.files"> {{ file.name }} </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion *ngIf="dirLibrary !== undefined">
        <ion-item slot="header" color="light">
          <ion-label>Library: {{ dirLibrary.files.length }}</ion-label>
        </ion-item>
        <div slot="content">
          <ion-item *ngFor="let file of dirLibrary.files"> {{ file.name }} </ion-item>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </ng-container>
</ion-content>
